import { useTranslation } from 'react-i18next'

const useCustomTranslation = () => {
  const { t, i18n } = useTranslation()

  const getTranslatedKey = (key, options = {}) => { // function to get translated keys
    return t(key, options)
  }

  const changeLanguage = (lng) => { // function to change language
    i18n.changeLanguage(lng)
  }

  const getLanguageCode = () => i18n.language

  const getCapLanguageCode = () => i18n.language.toUpperCase()

  return {
    getTranslatedKey,
    changeLanguage,
    getLanguageCode,
    getCapLanguageCode
  }
}

export default useCustomTranslation
